import React , { Suspense , lazy } from 'react';

import { Route, BrowserRouter as Router } from 'react-router-dom';
import './App.css';

import "./sb-admin-2.css";
import Nav from './components/Nav/Nav'
import TopBar from './components/TopBar/TopBar'
import Dashboard from './pages/Dashboard/Dashboard';

const TechSkills = lazy(()=> import ( './pages/TechSkills/TechSkills'))
const Experience = lazy(()=> import ('./pages/Experience/Experience')) 
const Education = lazy(()=> import ('./pages/Education/Education')) 
const AboutMe = lazy(()=> import ('./pages/AboutMe/AboutMe')) 
const Contact = lazy(()=> import ('./pages/Contact/Contact')) 
const Projects = lazy(()=> import ('./pages/Projects/Projects')) 

const routing = (
  <Router>
  <div  id="page-top" style={{height: "100%"}}>
    <div id="wrapper">
      <Nav/>
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
        <TopBar/>
        <Suspense fallback={<h3>Loading....</h3>}>
          <div className="container-fluid">
            <Route path="/" exact component={Dashboard} />
            <Route path="/techSkills" component={TechSkills} />
            <Route path="/experience" component={Experience} />
            <Route path="/education" component={Education} />
            <Route path="/aboutMe" component={AboutMe} />
            <Route path="/contact" component={Contact} />
            <Route path="/projects" component={Projects} />
            </div>
            </Suspense>
        </div>
      </div>
    </div>
  </div>
    </Router>
  )
  

function App() {
  return routing;
}

export default App;
